import React from 'react'
import { Skeleton } from 'antd'

import MIFView from './MIF/MIFView'
import { SectionHeader } from '../SectionHeader'

import { useCaseViewContext } from '../../context'
import { useMifSelection } from './MIF/useMifSelection'

import { Container } from "../../Styles"

export const MIF = () => {
    const { caseDetails, activeRequest } = useCaseViewContext()
    const [mif, mifMetadata] = useMifSelection(caseDetails, activeRequest); // Use the custom hook

    return (
        <Container>
            <SectionHeader title="MIF" />
            <Skeleton loading={!caseDetails} paragraph={{ rows: 6 }}>
                <MIFView mif={mif} mifMetadata={mifMetadata} />
            </Skeleton>
        </Container>
    )
}